<template>
  <el-popover
    placement="right"
    width="400"
    style="margin-left: 5px"
    v-model="showBatchKp"
    trigger="manual">
    <el-form ref="formRef" :model="form" label-width="100px" label-position="right" class="custom-form">
      <el-form-item label="开票状态" prop="kpzt">
        <el-radio-group v-model="form.kpzt">
          <el-radio :label="0">未开票</el-radio>
          <el-radio :label="1">已开票</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="dialog-footer" style="float: right">
        <el-button @click="handleClose" size="mini">取 消</el-button>
        <el-button type="primary" @click="handleSubmit"  size="mini">确 定</el-button>
      </div>
    </el-form>
    <el-button slot="reference" size="small" type="warning" @click="handleClick">批量审核开票</el-button>
  </el-popover>
</template>
<script>
import {defineComponent, reactive, ref} from "@vue/composition-api";
import useRootSetting from '@/hooks/useRootSetting'
import {Message} from "element-ui";
export default defineComponent({
  props: {
    showBatchKp: {
      type: Boolean,
      default: false
    },
    selectedIds: {
      type: [Array,Number],
      default: 0
    }
  },
  setup(props, {emit}) {
    const {getIsMobile} = useRootSetting()
    const formRef = ref(null)
    const form = reactive({
      kpzt: '',
    })
    const visible = ref(false)

    const handleSubmit = () => {
      formRef.value.validate(valid => {
        if (valid) {
          emit('submit', form,'batch')
        }
      })
    }
    const handleClose = () =>  emit('update:showBatchKp', false)

    const handleClick = () => {
      if(props.selectedIds == 0) {
        Message.warning('批量操作至少选择一条数据！')
      }else{
        emit('update:showBatchKp', true)
      }

    }

    return {
      visible,
      formRef,
      form,
      handleClick,
      handleSubmit,
      handleClose
    }
  }
})
</script>

